import React, { useState, useEffect } from 'react';
import ModalMarketingForm from 'components/Form/ModalMarketingForm';
import HeroSubscribeForm from 'components/Form/HeroSubscribeForm';
import Button from 'components/Core/Button';
import { CTAContainer } from './styles';

const HeroContextualCTA = ({
  className,
  content,
  dataPosition,
  ctaPosition,
  formType,
  inlineMarketingForm,
  fullWidth,
}) => {
  const [isMarketingModalOpen, toggleIsMarketingModalOpen] = useState(false);
  const [search, setSearch] = useState(undefined);
  useEffect(() => {
    setSearch(window?.location?.search);
  }, []);

  let CTA = null;

  if (content) {
    const contextualCtaNode = content[0] || content;
    const typeName = contextualCtaNode.__typename;

    if (typeName === 'ContentfulCallToAction') {
      CTA = contextualCtaNode.useModalForm ? (
        <>
          <Button
            type={contextualCtaNode.color}
            dataPosition={dataPosition || 'Dynamic Hero - CTA'}
            ctaPosition={ctaPosition || ''}
            style={{ marginTop: '40px', marginRight: '20px', whiteSpace: 'nowrap' }}
            onClick={() => toggleIsMarketingModalOpen(true)}
          >
            {contextualCtaNode.buttonLabel}
          </Button>

          <ModalMarketingForm
            dataPosition={dataPosition}
            formType={formType}
            isModalOpen={isMarketingModalOpen}
            onModalCancel={() => toggleIsMarketingModalOpen(false)}
            inlineMarketingForm={contextualCtaNode.modalForm}
            onFormSuccess={() => toggleIsMarketingModalOpen(false)}
          />
        </>
      ) : (
        <Button
          type={contextualCtaNode.color}
          dataPosition={dataPosition || 'Dynamic Hero - CTA'}
          ctaPosition={ctaPosition || ''}
          style={{ marginTop: '40px', marginRight: '20px', whiteSpace: 'nowrap' }}
          to={`${contextualCtaNode.url}${
            contextualCtaNode.carryUtmParameters && search ? search : ''
          }`}
        >
          {contextualCtaNode.buttonLabel}
        </Button>
      );
    } else if (typeName === 'ContentfulInlineMarketingForm') {
      CTA = (
        <>
          {inlineMarketingForm && (
            <HeroSubscribeForm
              dataPosition={dataPosition}
              inlineMarketingForm={inlineMarketingForm}
              formType={formType}
              style={{ display: 'none' }}
              id="Testing Hero Form"
              notificationMessage=""
              allowMultiSubmissions
              revealProps={false}
              dataTestId="hero-cta-inline-form"
            />
          )}
          <HeroSubscribeForm
            dataPosition={dataPosition}
            inlineMarketingForm={contextualCtaNode}
            formType={formType}
            notificationMessage=""
            allowMultiSubmissions
            revealProps={false}
            dataTestId="hero-subscribe-form"
          />
        </>
      );
    }

    CTA = (
      <CTAContainer fullWidth={fullWidth} className="cta-container">
        <div className={`hero-contextual-cta--origin ${className || ''}`}>{CTA}</div>
      </CTAContainer>
    );
  }

  return CTA;
};

export default HeroContextualCTA;
